/** @jsxImportSource @emotion/react */
import React from 'react'
import { InfoApplyForm, InfoApplyPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/InfoApplyContext'
import { breadcrumbItems } from '../../utils'

const { index, contentManagement, infoApplyManagement } = breadcrumbItems

const InfoApplyCreate: React.FC = () => {
  return (
    <Provider>
      <div css={styles.root}>
        <div css={styles.main}>
          <InfoApplyForm />
        </div>
        <div css={styles.right}>
          <InfoApplyPreview />
        </div>
      </div>
    </Provider>
  )
}

export default InfoApplyCreate;
